import {createTRPCReact} from "@trpc/react-query";
import type {AppRouter} from "@nosible/api";

/**
 * tRPC React hooks
 */
export const trpc: ReturnType<typeof createTRPCReact<AppRouter>> =
  createTRPCReact<AppRouter>();
